import React from "react"
import { Box } from "@rebass/grid/emotion"

import Tag from "../../nova/tag/tag"
import TravelKitCard from "./gwpcatccard"
import { Wrap } from "./gwpatcarea.styled"

const GwpAtcAreabanner = ({ data, handleGwpModal }) => {
  const { card, lineImage, planeImage, tag } = data

  return (
    <Wrap onClick={handleGwpModal}>
      <Box className="relative line-graphic-box mx-auto text-center">
        <img src={planeImage} alt={``} role="presentation" className="w-full" />

        <Box className="tag-box">
          <Tag
            data={{
              line: tag.line,
              classes: `${tag.classes || "bg-men-secondary-alt"}`,
            }}
          />
        </Box>
      </Box>

      <TravelKitCard data={card} />

      <Box>
        <img src={lineImage} alt={``} role="presentation" />
      </Box>
    </Wrap>
  )
}

export default GwpAtcAreabanner
